import { createTheme } from '@mui/material/styles';

export const getTheme = (fontFamily) => {
  return createTheme({
    typography: {
      fontFamily: fontFamily,
      button: {
        textTransform: 'none',
        fontFamily: fontFamily,
        fontSize: '18px',
      },
      h1:{
            fontFamily: fontFamily,
        },
        body1:{
            fontFamily: fontFamily,
        },
    },
    components: {
      MuiAccordion:{
            styleOverrides:{
                root:{
                    backgroundColor:'transparent',   
                },
            },
        },
        MuiAccordionSummary:{
            styleOverrides:{
                root:{
                    fontFamily:fontFamily,
                    fontSize:'18px',
                }
            }
        },
        MuiAccordionDetails:{
            styleOverrides:{
                root:{
                    border:'none',
                    borderBottom:'none',
                }
            }
        }
    }
  });
};